// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Vuetify
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

import { ja } from 'vuetify/locale';

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'ja',
    messages: { ja }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          background: '#E8EAF6',
          primary: '#3949AB',
          secondary: '#1E88E5'
        }
      }
    }
  }
});
